import React from "react";
import { useSelector } from "react-redux";
import { Chip } from "@material-ui/core";
import { useMemo } from "react";

const ProductTag = ({ product, isSearch, placement = "down", discount = false, nextToDiscount = false, productInCategoryDetails = false }) => {
  const { settings, language, tags } = useSelector((state) => ({
    settings: state.store.store.settings,
    language: state.store.language,
    tags: state.store.store.tags,
  }));
  const layout = isSearch ? "list" : settings.store_layout;
  const checkForProductTag =
    settings.enable_product_tag_staff &&
    settings.enable_product_tag &&
    product.tag !== null;
  const rightPosition = () => {
    if (language === "arabic") {
      return layout === "jumbo" ? 20 : 10;
    }
    return "";
  };
  const leftPosition = () => {
    if (language === "english") {
      return layout === "jumbo" ? 20 : 10;
    }
    return "";
  };

  let productTag = checkForProductTag
    ? tags.find((tag) => tag.id === product.tag)
    : null;

  if (!checkForProductTag || !productTag) {
    return null;
  }

  if ((layout === "list" || layout === "list-collapse") && !productInCategoryDetails) {
    return (
      <div
        style={{
          textAlign: language === "english" ? "left" : "right",
        }}
      >
        <Chip
          label={
            language === "english" ? productTag?.text_en : productTag?.text_ar
          }
          size={"small"}
          style={{
            backgroundColor: productTag?.color,
            color: "white",
            fontSize: "12px",
            fontWeight: "bold",
            marginBottom: placement == "top" ? 3 : placement == "down" ? 5 : 0,

            bottom: placement == "top" ? 0 : placement == "down" ? 5 : 0,
            left: language === "arabic" && 24,
          }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        position: "absolute",
        bottom: placement == "down" && "35px",
        left: leftPosition(),
        top: placement == "top" ? discount ? nextToDiscount ? "8px" : "35px" : "10px" : null,
        marginLeft: language === "english" && placement == "top" && discount && nextToDiscount && "48px",
        marginRight: language === "arabic" && placement == "top" && discount && nextToDiscount && "48px",
        padding: "1px 5px",
        borderRadius: 3,
        fontSize: "16px",
        fontWeight: "bold",
        textAlign: "left",
        backgroundColor: productTag?.color,
        color: "white",
        direction: language === "english" ? "ltr" : "rtl",
        right: rightPosition(),
      }}
    >
      {language === "english" ? productTag?.text_en : productTag?.text_ar}
    </div>
  );
};

export default ProductTag;
